export default {
  maxLimit: "Il limite massimo non deve superare le sei cifre.",
  emptyDeforestationStatus: "Lo stato di deforestazione dell'EUDR è vuoto.",
  meter: "Metro",
  kiloMeter: "Chilometro",
  gram: "Grammo",
  kilogram: "Chilogrammo",
  pound: "Libbra",
  cubicKilo: "Chilometro cubo (km³)",
  cubicMeter: "Metro cubo (m³)",
  cubicCentimeter: "Centimetro cubo (cm³)",
  cubicMilimeter: "Millimetro cubo (mm³)",
  used: "Usato",
  warning: "Avvertimento",
  deleteFarmH: "Sei sicuro di voler eliminare questo agriturismo?",
  deleteFarmMsg:
    "Si prega di fornire ulteriore conferma come la cancellazione di questo agriturismo cancellerà tutti i dati relativi all'azienda come raccolti, report ecc",
  selectFileToUpload: "Selezionare il file per caricare i dati",
  totalRecords: "Totale record",
  success: "Successo",
  recordsImported: "I record importati",
  psw: "Password",
  topFive: "Top 5",
  deleted: "Eliminato con successo",
  failed: "Sfigato",
  fermentation: "Fermentazione",
  confPsw: "Conferma la password",
  newPsw: "Nuova password",
  email: "Email",
  emailId: "Email ID",
  submit: "Inviare",
  cancel: "Annulla",
  faqs: "FAQ",
  id: "ID",
  processor: "Processore",
  cuppingScore: "Punteggio di assaggio",
  label: "Etichetta",
  expiry: "Scadenza",
  users: "Utenti",
  language: "Lingua",
  appUser: "App utente",
  app_users: "Utenti di app",
  offline_users: "Utenti offline",
  dimitraAdmin: "Dimitra Admin",
  admin_users: "Amministratori utenti",
  search: "Ricerca",
  searchByProducerName: "Cerca per nome del produttore",
  searchBy: "Cerca {type}",
  firstName: "Nome",
  lastName: "Ultimo nome",
  mobile: "Mobile",
  mobileNumber: "Numero mobile",
  department: "Dipartimento",
  departmentName: "Nome del Dipartimento",
  role: "Role",
  status: "Stato",
  permission: "Permissioni",
  activity_log: "Log attività",
  profile_auth: "Autenticazione del profilo",
  countryCode: "Codice paese",
  selectDept: "Seleziona il Dipartimento",
  selectRole: "Selezionare Role",
  edit: "Modifica",
  update: "Aggiornamento",
  delete: "Cancella",
  view: "Vista",
  VIEW: "Vista",
  deactivate: "Disattivare",
  activate: "Attivare",
  serverError: "Qualcosa è andato storto. Per favore prova dopo qualche volta.",
  minute: "Minute",
  perHour: "Per ora",
  day: "Giorno",
  enterDescription: "Inserisci la tua descrizione qui",
  enterHere: "Inserisci qui",
  enterMobile: "Inserisci il numero mobile",
  phoneRequired: "Il telefono è richiesto",
  phoneValid: "Il telefono deve essere valido",
  unableToUpdate: "Non è possibile aggiornare",
  membershipPlans: "Piani di adesione",
  byWeek: "Rassegna",
  byMonth: "Da Mese",
  byYear: "Per anno",
  custom: "Personale",
  name: "Nome",
  warehouse: "Magazzino",
  regionState: "Regione/Stato",
  hour: "Ore",
  days: "Giorni",
  minutes: "Processo verbale",
  provinceState: "Provincia/Stato",
  cityTown: "Villaggio/Città/Abito",
  village: "Villaggio",
  membershipValidity: "Validità dell'iscrizione di base",
  basicPlanValidity: "Validazione del piano di base",
  membershipExpiryDate: "Data di scadenza",
  extendedValidity: "Validità estesa",
  exportAsCSV: "Esportazione come CSV",
  filterBy: "Filtra per",
  autoCondition: "Condizioni",
  conditional: "Condizione",
  comingSoon: "Arrivo presto",
  userRole: "Ruolo utente",
  addUserRole: "Aggiungi il ruolo utente",
  editUserRole: "Modifica ruolo utente",
  additionalInformationRequired: "Informazioni aggiuntive Obbligo",
  back: "Indietro",
  browse: "Sfoglia",
  clearAll: "CLEARE",
  filterByRegion: "Filtra per Regione",
  continue: "Continua",
  resolveNow: "Risolvi ora",
  description: "Designazione",
  selectWeek: "Settimana di selezione",
  hideSplash: "Nascondi Splash?",
  hideLogo: "Nascondi il logo?",
  confirm: "CONFERMA",
  selectMonth: "Seleziona mese",
  selectDateRange: "Seleziona l'intervallo di date",
  regionDistrict: "Regione/Distretto",
  address: "Indirizzo",
  familyTribe: "Tribe della famiglia",
  website: "Sito web",
  deactivated: "Disattivato",
  active: "Attivo",
  inactive: "Inattivo",
  scheduled: "Programmato",
  country: "Paese",
  state: "Stato",
  farmer: "Farmer",
  commodity: "Commodità",
  quantity: "Quantità",
  unit: "Unità",
  price: "Prezzo",
  save: "SALVA",
  remove: "Rimuovi",
  stateIsReq: "Stato richiesto",
  cityIsReq: "La città è richiesta",
  addressIsReq: "Indirizzo è richiesto",
  membershipTypeReq: "Il tipo di iscrizione è richiesto",
  extendedReasonReq: "Esegui la ragione",
  numberOfDaysReq: "Numero di giorni è richiesto",
  extendedMembershipValidity: "Validità estesa dell'iscrizione",
  set: "SET",
  adminRole: "Admin Role",
  typeMsg: "Digitare il messaggio qui",
  mile: "Miglio",
  manageFarmer: "Gestire Farmer",
  manageOfflineFarmers: "Gestire Farmers Offline",
  dashboardSettings: "Impostazione di Dashboard",
  weightUnit: "Unità di peso",
  done: "Fatto",
  noRecordFound: "Nessun record trovato",
  farmerName: "Nome del coltivatore",
  production: "Produzione",
  registered: "Registrato",
  downloadForReport: "RELAZIONE PDF",
  downloadPdfReport: "Scarica PDF Relazione",
  notifications: "Notifica",
  markAllAsRead: "Segna tutto come letto",
  viewNotifications: "Visualizza le notifiche",
  youAreUpToDate: "Sei aggiornato",
  sendNotifications: "Notifiche di passaggio",
  createNotification: "Crea notifica",
  viewAllNotifications: "Visualizza tutte le notifiche",
  createNotificationForGroup: "Crea notifica per il gruppo/utenti multipli",
  createNotificationForDimitra: "Crea notifica per l'amministratore di Dimitra",
  pleaseCheckTickMark:
    "Si prega di controllare il segno di spunta per aggiungere l'utente nell'elenco",
  clearAllFilters: "Cancella tutti i filtri",
  note: "*Nota: Solo il file Mp4 è supportato per il video",
  validMemberships: "Abbonamenti validi",
  memberShipPlanMessage:
    "Sei sicuro di voler eliminare questo piano di appartenenza?",
  deleteMemberShipPlan: "Eliminare l'iscrizione Piano",
  systemAutoLogout: "Sistema si auto Logout in 2 min",
  monday: "Lunedì",
  tuesday: "Martedì",
  Wednesday: "Mercoledì",
  thursday: "Giovedì",
  friday: "Venerdì",
  saturday: "Sabato",
  sunday: "Domenica",
  addnewOfflineFarmer: "Aggiungi nuovo contadino offline",
  export: "Esportazione",
  exportAs: "Esportazione come",
  createNewOfflineFarmer: "Crea nuovo Farmer Offline",
  offlineFarmerForByingStationOnly:
    "Offline Farmer solo per l'acquisto della stazione (locale)",
  offlineFarmerForAllByingStations:
    "Farmer Offline per tutte le stazioni di acquisto (Global)",
  noDataAvailable: "Nessun dato disponibile",
  buyingStation: "Comprare la stazione",
  dryMillingStation: "Stazione di macinazione a secco",
  mergeWithExistingAccount: "Unisciti a un account esistente",
  createNewAccount: "Crea nuovo account",
  mobileOrEmailRequiredForRegister:
    "Per registrare l'app, almeno un dettaglio deve essere fornito sia numero di cellulare o e-mail.",
  selectLanguage: "Seleziona la lingua",
  basicPlan: "Piano di base",
  local: "Locale locale",
  newUser: "Nuovo utente",
  merged: "Merito",
  global: "Globale",
  qrcode: "Codice QR",
  goBack: "Indietro",
  profile: "Profilo",
  pleaseChooseAnImageFile: "Si prega di scegliere un file immagine",
  fileIsTooBigSelectUnder1MB:
    "Il tuo file è troppo grande! Seleziona un'immagine sotto 1MB",
  pleaseTryAgainAfterSometime: "Si prega di provare dopo qualche tempo",
  somethingWentWrong: "qualcosa è andato storto.",
  passwordChangedSuccesFully: "Password modificata con successo",
  passwordDoesNotMatch: "Le password non corrispondono",
  copyToCliped: "Copied a clipboard",
  profileUpdated: "Profile data updated.",
  emailAndMobileCantbeEmpty:
    "Email e Mobile, entrambi non possono essere vuoti.",
  changePassword: "Cambia password",
  generateSecurePassword: "Generare password sicura",
  restoreDefault: "Ripristinare Default",
  customization: "Personalizzazione",
  recordsPerPage: "Registrazioni per Pagina",
  Honey: "Tesoro",
  "Natural (Dry)": "Naturalmente (Droog)",
  Wine: "Vino",
  "Semi-Washed": "Mezza Croci",
  "Full-Washed": "Croci totali",
  lessThanOneMonth: "Meno Poi 1 Mese",
  oneTo8Month: "1-8 mesi",
  sixTo12Month: "6-12 Mesi",
  moreThanYear: "Più di 1 anno",
  emailSentSuccessfully: "Email inviata con successo",
  step: "Passo",
  fileError: "Errore del file",
  ProvideFileFormat:
    "Nota importante: si prega di fornire il seguente formato (PNG/JPEG)",
  signHere: "Firma qui",
  numOfDaysRemaining: "Numero di giorni rimanenti",
  requesterNameIsRequired: "Il nome del richiedente è richiesto",
  messageIsRequired: "Il messaggio è richiesto",
  emailIsInvalid: "L'email non è valida",
  emailIsRequired: "L'email è richiesta",
  read: "Leggere",
  unread: "Non letto",
  all: "Tutti",
  filesSucessfullyUploaded: "File caricati con successo",

  unsynced_record: "Registrazione non sincronizzata",

  loadingData: "Caricamento dati...",
  markAsRead: "Mark Come leggere",
  membership: {
    remainingDays: "Numero di giorni prolungati",
    type: "Tipo di iscrizione",
    validity: "Validità degli iscritti",
    validityLength: {
      custom: "Personale",
      expired: "Scadenza",
      oneTo8Months: "1-8 mesi",
      lessThan1Month: "Meno di 1 mese",
      moreThan1Month: "Più di 1 anno",
      sixTo12Months: "6-12 mesi",
    },
  },
  of: "di",
  ok: "OK",

  orderBy: "Ordina per",
  select: "Seleziona",
  type: "Tipo",
  uploadImageVideo: "Carica immagini",
  user: "Utente",
  userName: "Nome utente",
  usersSelected: "Utenti Selezionati",
  topics: "Argomenti",
  date: "Data",
  addNew: "ADD NUOVO",
  exportAsCsv: "Esportazione come CSV",
  noData: "Nessun dato trovato",
  dashboard: "Dashboard",
  mainDashboard: "Dashboard principale",
  userDashboard: "Dashboard utente",
  areYouSureText: "Sei sicuro di voler agire.",

  tickets: {
    actions: {
      create: "Crea ticket",
      delete: "Cancella biglietto",
      edit: "Modifica ticket",
    },
    areaOfRequest: "Area di richiesta",
    assignee: "Asignee",
    deleteTicket: {
      confirmation: "Sei sicuro di voler eliminare il ticket {0}?",
    },
    dueDate: "Data di scadenza",
    filters: {
      ticketFor: "Ticket per",
    },
    form: {
      ticketType: {
        admin: "Crea biglietto per Dimitra Admin",
        user: "Crea biglietti per l'utente App",
      },
    },
    markAsRead: "Mark come letto",
    messages: {
      created: {
        success: "Biglietto creato con successo",
      },
      deleted: {
        success: "Biglietto cancellato con successo",
      },
    },
    noData: "Nessun ticket trovato!",
    noDataHelpText:
      "Non ti è ancora stato assegnato alcun ticket.{0}{1}Fai clic sul pulsante \"Crea ticket\" in cima a questa schermata per iniziare.",
    pickerInMenu: "Picker nel menu",
    priority: {
      high: "Alto",
      label: "Priorità",
    },
    reply: "Rispondi",
    requestedDateTime: "Data e ora richiesti",
    requestorDetails: "Dettagli del richiedente",
    requestorEmail: "Email",
    subject: "soggetto",
    ticketsForItems: {
      all: "Tutti",
      dimitraAdmin: "Dimitra Admin",
      multipleUsers: "Utenti multipli",
      singleUser: "Utente singolo",
    },
    title: "Ticket",
  },

  faqSection: {
    createFaq: "DOMANDE FREQUENTI",
    createTopic: "Creare un argomento",
    selectTopic: "Seleziona argomento",
    faqQuestion: "Domande frequenti",
    faqAnswer: "FAQ Risposta",
    uploadImgVid: "Immagini e video",
    disInFaq: "Visualizza nella sezione FAQ",
    editFaq: "Modifica FAQ",
    topicName: "Nome del documento",
    parentTopic: "Argomento principale",
    editTopic: "Modifica argomento",
    createSection: "Si prega di creare prima sezione",
    createTopicFirst: "Si prega di creare argomento prima",
    questionReq: "FAQ La domanda è richiesta",
    answerReq: "FAQ La risposta è richiesta",
  },

  cropsReport: "Rapporto Crops",
  today: "Oggi",
  week: "Rassegna",
  month: "Mese",
  year: "Anno",
  cropsStatistics: "Crops Statistiche",
  crops: "Colture",
  acres: "Acri",
  totalPlantedArea: "Superficie totale delle piante",
  farmersChart: "Grafico degli agricoltori",
  cropsName: "Nome dei raccolti",
  farmers: "Agricoltori",
  farms: "Aziende agricole",
  planted: "Piante",
  plantedArea: "Area vegetale",
  harvested: "Vendemmia",
  yieldAcre: "Rendimento/Acre",
  selectCrop: "Seleziona il raccolto",
  listByYield: "Elenco di Yield",
  listByPlantedArea: "Elenco per Area Pianta",
  equipmentReport: "Relazione sull'attrezzatura",
  equipmentChart: "Grafico dell'attrezzatura",
  selectFarmer: "Seleziona Farmer",
  selectFarmers: "Seleziona Farmers",
  equipmentName: "Nome dell'attrezzatura",
  region: "Regione",
  counts: "Conti",
  large: "Grande",
  medium: "Media",
  small: "Piccolo",
  listByFarmer: "Elenco per Farmer",
  rowsPerPage: "Righe per pagina",
  farmersReport: "Relazione sugli agricoltori",
  farmsReport: "Relazione sulle aziende agricole",
  farmersStatistics: "Statistiche degli agricoltori",
  farmStatistics: "Statistiche agricole",
  averageFarmerLand: "Terreno medio agricolo",
  totalFarmerLand: "Totale terreno agricolo",
  largeFarmers: "Grandi agricoltori",
  mediumFarmers: "Agricoltori medi",
  smallFarmers: "Piccoli agricoltori",
  listByLand: "Elenco per Land",
  listByFarm: "Elenco delle aziende agricole",
  AvgLandAcre: "Avg. Terra/Acre",
  listbyCrop: "Elenco per Crop",
  listbyZone: "Elenco per Zone",
  farmName: "Nome dell'azienda",
  zones: "Zone",
  area: "Settore",
  goalsAchievedReport: "Obiettivi",
  listByCrops: "Elenco per Crops",
  goalsAchievedChart: "Obiettivi raggiunti Grafico",
  goalsAchieved: "Obiettivi raggiunti",
  goalsFailed: "Obiettivi falliti",
  successRate: "Tasso di successo",
  achieved: "Conseguito",
  equipment: "Attrezzatura",
  pests: "Pests",
  regions: "Regioni",
  filterByCrops: "Filtra per Crops",
  searchCrops: "Cerca colture",
  batchCode: "Codice di Batch",
  batchRating: "Valutazione della posizione",
  MakeASelection: "Fai una selezione",
  typeTotalCoffeeQuantity: "Tipo quantità totale di caffè",
  typeHumidity: "Tipo di umidità",
  valueInPercent: "valore in %",
  purchaseOrderRequired: "Ordine di acquisto è richiesto",
  totalCoffeeCherryRequired: "Il totale delle ciliegie di caffè è obbligatorio",
  processTypeRequired: "Il tipo di processo è richiesto",
  fermentationTypeRequired: "Il tipo di fermentazione è richiesto",
  stationInfo: "Informazioni sulla stazione",
  purchaseOrders: "Ordini di acquisto",
  processingBatch: "Elaborazione Batch",
  processedCoffeeOutRequired: "Caffè lavorato Fuori è richiesto",
  lotNo: "No",
  addNewS: "Aggiungi nuovo",
  viewAll: "Vedi tutto",
  parchmentOut: "Fuori dal pavimento",
  processingDone: "Fatto di elaborazione",
  farmerLotID: "Farmer & Lot ID",
  weight: "Peso",
  plantationSettings: "Impostazioni di impianto",
  PlantationsEachFarmerCanCreate:
    "No. delle piantagioni Ogni agricoltore può creare",
  manageAdditionalPlantationRequests:
    "Gestire richieste di impianto aggiuntive",
  autoApprove: "Approvo Auto",
  adminApprovalRequired: "Admin Approval richiesto",
  close: "Chiudi",
  new_user: "Nuovo utente",
  KGAcre: "KG / Acre",
  honey: "Tesoro",
  naturalDry: "Naturale (Dry)",
  wine: "Vino",
  SemiWashed: "Semi-lavato",
  fullWashed: "Completamente lavato",
  startDateRequired: "Data di inizio è richiesto",
  endDateRequired: "La data di fine è richiesta",
  assigned: "Assegnata",
  activated: "Attivato",
  unassigned: "Non firmata",
  deleteTopic: "Eliminare argomento",
  sureToDeleteTopic:
    "Sei sicuro di voler eliminare problemi tecnici argomento?",
  publishSurvey: "Pubblica Indagine",
  endSurvey: "Indagine finale",
  copy: "Copia",
  pending: "Finanziamenti",
  "Farmer Name": "Nome del coltivatore",
  "Goals Achieved": "Obiettivi raggiunti",
  "Goals Failed": "Obiettivi falliti",
  "Success Rate": "Tasso di successo",
  "Farm Size": "Dimensione della fattoria",
  "Small Farmer": "Piccolo agricoltore",
  "Medium Farmer": "Agriturismo medio",
  "Large Farmer": "Grande agricoltore",
  "Equipment Name": "Nome dell'attrezzatura",
  Farmer: "Farmer",
  Counts: "Conti",
  "Pest Name": "Nome della lista",
  "Total Area": "Superficie totale",
  Region: "Regione",
  Crop: "Coltura",
  "Crop Name": "Nome del raccolto",
  Farmers: "Agricoltori",
  Farms: "Aziende agricole",
  Planted: "Piante",
  "Planted Area": "Area vegetale",
  Harvested: "Vendemmia",
  "Yield/acre": "Rendimento/acre",
  "Region Name": "Nome della Regione",
  "Avg. Land/Acre": "Avg. Terra/Acre",
  Crops: "Colture",
  "Yield/area": "Rendimento/area",
  "Avg. land/Acre": "Avg. terreno/Acre",
  "Farm Name": "Nome dell'azienda",
  Zones: "Zone",
  Area: "Settore",
  "Goals Achieved Report": "Obiettivi",
  "Farms Report": "Relazione sulle aziende agricole",
  "Pest Report": "Relazione Pest",
  "Equipment Report": "Relazione sull'attrezzatura",
  "Crops Report": "Rapporto Crops",
  "Farmers Report": "Relazione sugli agricoltori",
  "Regional Report": "Relazione regionale",
  fermentationCode: "Codice di fertilizzazione",

  months: "Mesi",
  open: "Aperto",
  closed: "Chiuso",
  moreInfoRequired: "Ulteriori informazioni richieste",
  publicDueDiligenceReportSettings: "Impostazioni report di controllo pubblico",
  showingAll: "Mostrando tutto",
  fieldRequired: "Questo campo è obbligatorio.",
  valueMustBeGreaterThanZero: "Il valore deve essere maggiore di zero.",
  valueExceedsLimit:
    "Il tempo di scadenza non può superare i 12 mesi secondo le normative EUDR.",
  valueMustBeInteger: "Il valore deve essere un numero intero.",
  viewDeforestationDetails: "Visualizza Dettagli Deforestazione",

  listOfShipments: "Elenco delle Spedizioni",
  viewShipment: "Visualizza Spedizione",
  shipmentCratedSuccess: "La spedizione è stata creata con successo.",
  pleaseSelectAtLeastOneDueDeligenceReport:
    "Si prega di selezionare almeno un rapporto di due diligence",
  confirmation: "Conferma",
  confirmDialog: {
    assessmentBuilder: {
      delete: {
        title: "Elimina Valutazione",
        message: "Sei sicuro di voler eliminare la Valutazione?",
        confirmBtn: "Confermare?",
      },
    },
    dueDiligenceReport: {
      delete: {
        title: "Elimina Rapporto di Due Diligence EUDR",
        message:
          "Sei sicuro di voler eliminare il Rapporto di Due Diligence EUDR?",
        confirmBtn: "Conferma",
      },
    },
    farm: {
      delete: {
        title: "Elimina Fattoria",
        message: "Sei sicuro di voler eliminare la Fattoria?",
        confirmBtn: "Conferma",
      },
    },
    status: {
      delete: {
        title: "Elimina Stato di Deforestazione",
        message: "Sei sicuro di voler eliminare lo stato di deforestazione?",
        confirmBtn: "Conferma",
      },
    },
  },

  timeAgo: {
    minute: "un minuto fa",
    minutes: "{count} minuti fa",
    hour: "un'ora fa",
    hours: "{count} ore fa",
    day: "un giorno fa",
    days: "{count} giorni fa",
    month: "un mese fa",
    months: "{count} mesi fa",
    year: "un anno fa",
    years: "{count} anni fa",
  },
  noUploadToBlockchain: "Nessun Caricamento su Blockchain",
  noDataForBlockchain:
    "Poiché non sono stati generati rapporti di deforestazione per i luoghi di produzione, non c'erano dati da scrivere sulla blockchain. Se questo era inaspettato, assicurati che i rapporti per le fattorie siano stati generati correttamente nei passaggi precedenti.",
  pleaseAgreeToDeclaration:
    "Si prega di accettare la dichiarazione per concludere.",
  importProductionPlaceTT:
    "Consente agli utenti di importare dati sul luogo di produzione utilizzando opzioni di caricamento o download di file.",
  defaultCircularGeofence:
    "Le fattorie senza una geofence o senza informazioni sulle loro dimensioni verranno assegnate una geofence circolare predefinita di 4 ettari. Se la dimensione media della fattoria è inferiore a 4 ettari, modificare la dimensione predefinita facendo clic sul pulsante 'Modifica' di seguito.",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon:
    "Secondo l'EUDR, le fattorie con meno di 4 ettari non richiedono un poligono.",
  uploadOneDeforestationAssessmentForAllFarms:
    "CARICA UNA VALUTAZIONE DELLA DEFORESTAZIONE PER TUTTE LE FATTORIE",
  uploadAssessment: "Carica Valutazione",
  seeDetails: "Vedi dettagli",
  clickHere: "Clicca qui",
  tutorials: {
    howtoCreateanAdminUser: "Come creare un utente amministratore",
    howToCreateanActivationKey: "Come creare una chiave di attivazione",
    individualandBulkFarmCreation: "Creazione individuale e in massa di aziende agricole",
    creatingaDueDiligenceStatement: "Creazione di una dichiarazione di due diligence",
    title: "Tutorial e Guide",
    noTutorials: "Nessun tutorial",
    addTutorialPrompt: "Si prega di aggiungere prima un tutorial o una guida.",
    videoNotAvailable: "Video non disponibile nella tua lingua preferita.",
    watchVideo: "Guarda il video",
    viewTutorial: "Visualizza tutorial",
    // Kenyan tutorials
    creatingAndManagingUsers: "Creazione e gestione utenti",
    howToCreateActivationKeys: "Come creare chiavi di attivazione",
    userRolesAndPermissions: "Ruoli e permessi utente",
    creatingAFarm: "Creazione di un'azienda agricola",
    creatingADueDiligenceStatement: "Creazione di una dichiarazione di due diligence",
    sharingStatementWithOperator: "Condivisione dichiarazione con operatore",
    riskMitigation: "Mitigazione del rischio",
    generalSettings: "Impostazioni generali",
    assessmentBuilder: "Costruttore di valutazioni",
    bulkUserUpload: "Caricamento massivo utenti",
    // Admin management
    manageTutorials: "Gestisci Tutorial",
    createTutorial: "Crea Tutorial",
    editTutorial: "Modifica Tutorial",
    deleteTutorial: "Elimina Tutorial",
    deleteConfirmation: "Sei sicuro di voler eliminare il tutorial '{title}'?",
    createSuccess: "Tutorial creato con successo",
    updateSuccess: "Tutorial aggiornato con successo",
    deleteSuccess: "Tutorial eliminato con successo",
    createError: "Errore nella creazione del tutorial",
    updateError: "Errore nell'aggiornamento del tutorial",
    deleteError: "Errore nell'eliminazione del tutorial",
    saveError: "Errore nel salvataggio del tutorial",
    loadError: "Errore nel caricamento dei tutorial",
    createFirstTutorial: "Crea il tuo primo tutorial per iniziare",
    // Form fields
    description: "Descrizione",
    url: "URL",
    urlType: "Tipo di Contenuto",
    displayOrder: "Ordine di Visualizzazione",
    organization: "Organizzazione",
    organizationHint: "Seleziona 'Globale' per tutorial disponibili per tutte le organizzazioni, o scegli un'organizzazione specifica",
    userType: "Tipo di Utente",
    userTypeHint: "Seleziona quale tipo di utenti può vedere questo tutorial",
    isActive: "È Attivo",
    status: "Stato",
    actions: "Azioni",
    // Status options
    active: "Attivo",
    inactive: "Inattivo",
    global: "Globale",
    // User types
    appUsers: "Utenti App",
    adminUsers: "Utenti Admin",
    // Validation messages
    titleRequired: "Il titolo è richiesto",
    titleMinLength: "Il titolo deve essere di almeno 3 caratteri",
    urlRequired: "L'URL è richiesto per i link esterni",
    urlInvalid: "Si prega di inserire un URL valido",
    urlTypeRequired: "Il tipo di contenuto è richiesto",
    fileRequired: "Il file è richiesto per tutorial basati su file",
    urlOrFileRequired: "Deve essere fornito URL o file",
    // Search functionality
    searchOrganizations: "Cerca organizzazioni...",
    noOrganizationsFound: "Nessuna organizzazione trovata",
    searchTutorials: "Cerca tutorial...",
    selectOrganization: "Seleziona organizzazione...",
    excludeGlobalForOrg: "Escludi tutorial globali per organizzazione",
    exclusionUpdateSuccess: "Configurazione tutorial organizzazione aggiornata con successo",
    exclusionUpdateError: "Errore nell'aggiornamento della configurazione tutorial organizzazione",
    exclusionStatusLoadError: "Errore nel caricamento della configurazione tutorial organizzazione",
  },

  helpDesk: "Assistenza",
  generateSecretKey: "Genera Chiave Segreta",
  secretKey: "Chiave Segreta",
  secretKeyCopied: "Chiave segreta copiata negli appunti",
  copied: "Copiato",
  copySecretKeyHint: "Clicca sull'icona di copia per copiare la chiave segreta",
};
